import React, { useState, useEffect, useContext, useMemo, useCallback } from "react";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import "../../styles/navbar/navbar.css";
import calqueLogo from "../../assets/images/calque_prototype.png";
import {NavLink, Link as RouterLink, useNavigate } from "react-router-dom";
import ChangePassword from "../../auth/ChangePassword";
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { ApplicationStatusContext } from "../../context/FormContext";
import config from "../../config/Config";
import { ReactComponent as Star1 } from "../../assets/images/icons/star1_icon.svg";
import { ReactComponent as Star2 } from "../../assets/images/icons/star2_icon.svg";

const menuItems = [
  // { label: "Calque AI", hrefs: ["/calque-ai"] },
  { label: "Trade in Application", hrefs: ["/application-listing","/application-create"] },
  { label: "Users", hrefs: ["/user-listing","/user"] },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [
      cxSpecialist,
      setCxSpecialist,
      newApplicationStatus,
      setNewApplicationStatus,
      cxSpecialists,
      setCxSpecialists
  ] = useContext(ApplicationStatusContext)
  var user_info = localStorage.getItem("user_info");
  let first_name = JSON.parse(user_info).first_name;
  let last_name = JSON.parse(user_info).last_name;
  var icon_name = first_name.charAt(0).concat(last_name.charAt(0));
  const [auth, setAuth] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [isStaff, setIsStaff] = useState(false);
  const [changePasswordModal, setChangePasswordModal] = useState(false);
 
  const activeLabel = useMemo(() => {
    const currentPath = window.location.pathname;
    const activeItem = menuItems.find(item => item.hrefs.includes(currentPath));
    return activeItem ? activeItem.label : null;
  }, [window.location.pathname]);


  const userInfo = useMemo(() => {
    const data = localStorage.getItem("user_info");
    return data ? JSON.parse(data) : null;
  }, []);

  useEffect(() => {
    if (!userInfo) return;

    setAuth(true);
    setIsStaff(userInfo.is_staff || userInfo.groups?.some((tg) => tg.name === "Underwriter"));
  }, [userInfo]);
  
  useEffect(() => {
    var tokenStr = localStorage.getItem('access_token')
    fetch(`${config.baseUrl}get-cx-specialists/`,
      {
          headers: {
              'Accept': 'application/json',
              'Authorization': `Bearer ${tokenStr}`,
              'Content-Type': 'application/json'
          },
      })
      .then(async response => {
          const result = await response.json()
          if (response.status === 200 || response.status === 201) {
              setCxSpecialists(result)
          }
          else if (response.status === 403) {
              localStorage.setItem('access_token', '')
              navigate('/');
          }
      })
  }, [])

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function handleLogout() {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  }

  const handleChangePassword = () => {
    setChangePasswordModal(!changePasswordModal);
    // setAnchorEl(null);
  };

  function handleHeaderFunction(e) {
    localStorage.setItem("isCreate",false);
    setNewApplicationStatus(1);
  }

  const getMenus = useCallback((items) => {
    return items.map(({ label, hrefs }) => {
      const isActive = label === activeLabel || (label === "Calque AI" && window.location.pathname.startsWith("/calque-ai"));;
      const isCalqueAI = label === "Calque AI";
      return (
        <Button
          id={label}
          key={label}
          to={hrefs[0]}
          component={RouterLink}
          sx={{
            fontSize: "16px",
            fontFamily: "proxima-semibold",
            color: isActive ? "#407DE2" : "#000",
            marginLeft: "37px", 
            textTransform: "capitalize",
            ":hover": {
              color: isActive ? "#000" : "#407DE2",

              ...(isCalqueAI && {
                "& svg": {
                  fill: isActive ? "#000" : "#407DE2",
                },
                "& svg path": {
                  fill: isActive ? "#000" : "#407DE2",
                },
              }),
            },
            "& svg": {
              fill: isActive ? "#407DE2" : "#000",
            },
            "& svg path": {
              fill: isActive ? "#407DE2" : "#000",
            },
          }}
          onClick={(e) => handleHeaderFunction(e)}
        >
          {isCalqueAI && (
            <span className="navbar-sparkle-inline-wrapper">
              <Star2 className="nav-star-small" />
              <span className="nav-star-big-container">
                <Star1 className="nav-star-big" />
              </span>
            </span>
          )}
          {label}
        </Button>
      );
    });
  }, [activeLabel , window.location.pathname]);
  
  return (
    <header className="nav-container">
      <Toolbar className="nav-toolbar">
        <div className="nav-left">
          <img src={calqueLogo} alt="Calque Logo" className="h-100 w-100" />
        </div>
        <div className="nav-right">
          <div>{isStaff === true ? getMenus(menuItems) : getMenus(menuItems.filter(item => item.label === "Trade in Application"))}</div>
          {auth && (
            <div >
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="white"
                className="profile-icon"
              >
                {icon_name}
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                id="menu-appbar"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                slotProps={{
                  paper: {
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      mt: 1.5,
                      "&::before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 15,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem onClick={handleChangePassword}>
                  <LockOutlinedIcon sx={{fill:"#407DE2"}} />
                  <Typography className="profile-menus">Change Password</Typography> 
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                  <ExitToAppOutlinedIcon sx={{fill:"#407DE2"}}/> 
                      <Typography className="profile-menus">Logout</Typography>
                </MenuItem>
              </Menu>
            </div>
          )}
        </div>
      </Toolbar>
      <ChangePassword
          open={changePasswordModal}
          close={handleChangePassword}
        />
    </header>
  );
}
